import { isNull, isNumber, isString, isValidModel, isArray, normalizeArrayToObject } from '@models';
export enum BrandImageTypeEnum {
  White = 'White',
  Color = 'Color',
}
export type BrandImage = {
  url: string;
  type: BrandImageTypeEnum;
};
export interface Brand {
  id: number;
  name: string;
  description: string | null;
  imageUrl: string;
  logos: BrandImage[];
  caption: string;
  pointConversionRate?: number;
}

export interface BrandBanner {
  brandId: number;
  url: string;
}
export interface NormilizedBrand extends Brand {
  logoByType: Record<BrandImageTypeEnum, BrandImage>;
}
export const normilizeBrandImage = (brand: Brand): NormilizedBrand => {
  return {
    ...brand,
    logoByType: normalizeArrayToObject(brand.logos, 'type'),
  };
};
export const isBrand = (obj: any): obj is Brand => {
  return isValidModel<Brand>(obj, {
    id: isNumber,
    name: isString,
    imageUrl: isString,
    description: (value: any) => isNull(value) || isString(value),
    logos: isArray,
    caption: isString,
  });
};
